/**
 * Shared Paddle price ID catalog (pri_* only — not secrets).
 * Keep in sync with:
 *   llm_server/deployment_package/config/paddle_prices.json
 *
 * Env REACT_APP_PADDLE_PRICE_* / Vault PADDLE_PRICE_* still override at runtime.
 * Client/API keys (live_ / test_ / pdl_*) stay in Vault / .env — never here.
 */
// ***** Code Start BH10092026_1430 - Shared Dev/Prod Paddle pri_* map
export const PADDLE_PRICE_CATALOG = {
  monthly: {
    pro_plan: 'pri_01ktqsnzmedpmkzkx49b0fv7g5',
    developer_plus: 'pri_01ktqst5qt5n61wh9xkkjpw8v2',
    developer_ultimate: 'pri_01ktqswemtz5sjmabv52mxhy5r',
    pay_as_you_go: 'pri_01ka09anj6sd583j8nq4mnpnj7',
  },
  // Yearly pri_* must be distinct annual products. Fill via env/Vault or DB columns
  // until paddle_prices.json ships a yearly section with real IDs.
  yearly: {
    pro_plan: '',
    developer_plus: '',
    developer_ultimate: '',
    pay_as_you_go: '',
  },
  addonTokens: {
    1000000: 'pri_01ka7s22mzpy5s5pxt9v60zdhx',
    2000000: 'pri_01ka7s8x5qg4kdde43y8hrejd7',
    3000000: 'pri_01ka7sba42yb9mcpdhxvk2xxa1',
  },
};

export function catalogMonthlyPrice(planKey) {
  return String(PADDLE_PRICE_CATALOG.monthly[planKey] || '').trim();
}

export function catalogYearlyPrice(planKey) {
  return String(PADDLE_PRICE_CATALOG.yearly[planKey] || '').trim();
}

export function catalogAddonPriceByTokens(tokens) {
  return String(PADDLE_PRICE_CATALOG.addonTokens[Number(tokens)] || '').trim();
}
// ***** Code End BH10092026_1430

export default PADDLE_PRICE_CATALOG;
